const ABFieldFormulaCore = require("../../core/dataFields/ABFieldFormulaCore");
module.exports = class ABFieldFormula extends ABFieldFormulaCore {};
